var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_314_14881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9167 14.5833C39.5275 14.5833 40.8333 13.2775 40.8333 11.6667C40.8333 10.0558 39.5275 8.75 37.9167 8.75C36.3058 8.75 35 10.0558 35 11.6667C35 13.2775 36.3058 14.5833 37.9167 14.5833Z",
    stroke: "#222529",
    strokeWidth: 5.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 49.5833L26.2498 52.5L28.4373 48.125",
    stroke: "#222529",
    strokeWidth: 5.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7502 61.2502V49.5835L32.0835 40.8335L35.0002 23.3335",
    stroke: "#222529",
    strokeWidth: 5.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4165 35.0002V26.2502L34.9998 23.3335L43.7498 32.0835L52.4998 35.0002",
    stroke: "#222529",
    strokeWidth: 5.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_314_14881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRun);
export default __webpack_public_path__ + "static/media/run.d4443c89243c39a9aef9df4286343e3f.svg";
export { ForwardRef as ReactComponent };